import { Box, Tooltip } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { BomItemDetails } from "../../../../../explorer/types/SpareParts/BomItemDetails";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import { AppIconsChecklist } from "../../../AppIcons";
import GoToPage from "../../../GoToPage/GoToPage";
import { Site } from "../../../../../explorer/types/SpareParts";
import ImageTooltip from "../../../AppTooltip/ImageTooltip";
import { DRAWINGS_RESOURCES} from "../../../../configuration/Resources";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import useCurrentSite from "../../../../hook/useCurrentSite";

type TOpenNextLevelComponent = {
    item: BomItemDetails,
}

const OpenNextLevelComponent = (props: TOpenNextLevelComponent) => {

    const classes = useTableLayoutClasses();
    const [_, setNaturalKey] = useReduxState<string>(reduxStoreConfig.sparePartsCurrentNaturalKey);
    const [currentSite] = useCurrentSite();
    const {t} = useTranslation();

    const handleClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setNaturalKey(props.item.naturalKey);
        e?.stopPropagation();
    }

    let drawingFileName = props.item.drawingFileName;
    drawingFileName = drawingFileName ? `${DRAWINGS_RESOURCES}/${drawingFileName?.substring(0, 2)}/${drawingFileName}.png` : undefined;

    const icon = drawingFileName ? (
      <ImageTooltip imageStyle={{ maxWidth: 400 }} imagePath={drawingFileName}>
        <AppIconsChecklist />
      </ImageTooltip>
    ) : (
        <Tooltip placement="top" title={t("spareparts.goToAssembly")}>
      <AppIconsChecklist /></Tooltip>
    );

    return (
        <Box sx={[classes.columnReplaced]}>
            {!props.item.isLeaf &&
                <GoToPage page={"spareparts.machine"}
                    params={{
                        machineId: props.item.machineId,
                        naturalKey: props.item.naturalKey,
                        customerSiteCode: currentSite.customerSiteCode
                    }}
                    onClick={handleClick}
                    children={icon}
                />
            }
        </Box>
    )
}

export default OpenNextLevelComponent;